import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=7c64d858&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=7c64d858&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64d858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c64d858')) {
      api.createRecord('7c64d858', component.options)
    } else {
      api.reload('7c64d858', component.options)
    }
    module.hot.accept("./companyInfo.vue?vue&type=template&id=7c64d858&scoped=true", function () {
      api.rerender('7c64d858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/companyInfo.vue"
export default component.exports